import { Box, FormLabel } from '@mui/material';
import { RadioGroupControl } from 'components/RadioGroupControl';
import { TextV2 } from '@insights-ltd/design-library/components';
import { useTranslation } from 'react-i18next';
import { ScoreType } from 'types/types';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { useWheelContext, WheelState } from './hooks/useWheelContext';

const SelectTypeControl = () => {
  const { t } = useTranslation();
  const [{ scoreType }, setState] = useWheelContext();

  const handleChange = (newValue: string) => {
    setState((prevState: WheelState) => ({
      ...prevState,
      scoreType: newValue as ScoreType,
    }));
  };

  return (
    <>
      <FormLabel component="legend">
        <TextV2 variant="h3">
          {t('ui.event-management.events.team-wheel.select-type')}
        </TextV2>
      </FormLabel>
      <Box sx={(theme) => ({ mb: theme.spacing(spacingSizeMap.M) })} />
      <RadioGroupControl
        title={t('ui.event-management.events.team-wheel.select-type')}
        onChange={handleChange}
        value={scoreType}
        options={[
          {
            value: 'CONSCIOUS',
            label: t('ui.event-management.events.team-wheel.type.conscious'),
          },
          {
            value: 'LESS_CONSCIOUS',
            label: t(
              'ui.event-management.events.team-wheel.type.less-conscious',
            ),
          },
        ]}
      />
    </>
  );
};

export default SelectTypeControl;
